import { styled, Typography, WithTheme } from '@material-ui/core'
import { ContactStatus } from 'shared/types'
import { Icon as BaseIcon } from '@iconify/react'

interface ErrorProps extends WithTheme {
  contactStatus?: ContactStatus
}

export const Text = styled(Typography)(
  ({ theme, contactStatus }: ErrorProps) => ({
    color:
      contactStatus === ContactStatus.ERROR
        ? theme.palette.error.main
        : theme.palette.warning.main,
  })
)

export const Wrapper = styled('div')({
  display: 'flex',
})
export const Icon = styled(BaseIcon)(({ theme, contactStatus }: ErrorProps) => {
  const isError = contactStatus === ContactStatus.ERROR
  return {
    marginRight: theme.spacing(isError ? 1.6 : 1),
    color: isError ? theme.palette.error.main : theme.palette.warning.main,
  }
})
